import AudiencePage from "../components/marketing/AudiencePage";
import { SHOTS } from "../components/marketing/features";
import { C, cardBodyStyle } from "./Landing";

const STEPS = [
  { title: "Every coach gets the Chalkboard", tier: "league", shot: SHOTS.chalkboard,
    body: "Teams under League OS get The Chalkboard's coach tools: bulk Erase and Redraw, Draw It Up, recurring events and volunteers." },
  { title: "Changes reach families fast", tier: "league", shot: SHOTS.bulk,
    body: "When a field closes, each coach can shift or cancel a whole stretch of events, and each family gets one combined alert." },
];

export default function Leagues() {
  return (
    <AudiencePage
      id="leagues" docTitle="Chalk OS League OS: broadcasts and every team on one board"
      eyebrow="For leagues & commissioners" title="Every team." marker="One board."
      intro="League OS gives league admins a league-wide broadcast and an overview of every team, and gives each coach the full Chalkboard."
      steps={STEPS} featureTitle="What League OS includes." featureSub="Set up with you directly."
      features={["leagueBroadcast", "leagueOverview", "leagueTeams"]}
      cta="Talk to us" ctaHref="mailto:support@getchalkos.com?subject=League OS"
      extra={<p data-testid="leagues-setup-note" style={{ ...cardBodyStyle, fontSize: 15, color: C.muted, marginTop: 18 }}>
        League OS isn't self-serve yet. Email us and we'll set up your league, connect your teams and agree pricing for your season.</p>}
    />
  );
}
